import { traceEvent } from '@wk/wk-gatherer';
import { GetStaticProps } from 'next';
import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { NextSeo } from 'next-seo';
import React, { useEffect } from 'react';
import { useLocation } from 'react-use';

import Layout from '@/components/Layout';
import BookSection from '@/components/WukongReviews/BookSection';
import CaseSection from '@/components/WukongReviews/CaseSection';
import HeroSection from '@/components/WukongReviews/HeroSection';
import MediaSection from '@/components/WukongReviews/MediaSection';
import ReviewsSection from '@/components/WukongReviews/ReviewsSection';

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'common',
        'path',
        'form',
        'wukong-reviews',
      ])),
    },
  };
};

const WallOfLove = () => {
  const state = useLocation();
  // 用户之声页面曝光埋点
  useEffect(() => {
    traceEvent({
      data: {
        _event: 'D_WallofLove',
      },
    });
  }, []);

  // 处理 hash 锚点滚动
  useEffect(() => {
    const hash = window.location.hash?.replace('#', '');
    if (hash) {
      // 延迟执行以确保 DOM 已渲染
      const timer = setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 500);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <>
      <NextSeo
        openGraph={{
          url: state?.href,
          title: 'Wall of Love - WuKong Education',
          description:
            'Share your WuKong story on our Wall of Love. Read reviews from parents worldwide.',
          images: [
            {
              url: 'https://cdnwukong.com/images/public/og/offical-site-1.png',
              width: 300,
              height: 300,
              alt: 'Wall of Love - WuKong Education',
            },
          ],
        }}
      />
      <Head>
        <title>Wall of Love - WuKong Education</title>
        <meta
          name="description"
          content="Share your WuKong story on our Wall of Love. Read reviews from parents worldwide."
        />
      </Head>
      <main className="relative overflow-hidden lg:mb-[180px]">
        <HeroSection />
        <ReviewsSection />
        <CaseSection />
        <BookSection />
        <MediaSection />
      </main>
    </>
  );
};

export default WallOfLove;

WallOfLove.getLayout = (page: React.ReactElement) => <Layout>{page}</Layout>;
